import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {catchError, map, mergeMap, withLatestFrom} from 'rxjs/operators';
import {CampaignsService} from 'gamesis-story-client';
import {
    campaignsFailure,
    createCampaign,
    createCampaignSuccess,
    deleteCampaign,
    deleteCampaignSuccess,
    exitCampaign,
    loadCampaigns,
    loadCampaignsSuccess,
    setCampaign
} from './campaign.actions';
import {of} from 'rxjs';
import {selectCurrentCampaignId} from './campaign.selectors';
import {joinCampaignSuccess} from '../players/player.actions';

@Injectable()
export class CampaignEffects {
    loadCampaigns$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadCampaigns, createCampaignSuccess, deleteCampaignSuccess, joinCampaignSuccess),
            mergeMap((action) => {
                return this.service.listCampaigns().pipe(
                    map(campaigns => loadCampaignsSuccess({campaigns})),
                    catchError(error => of(campaignsFailure({error})))
                );
            })
        )
    );

    createCampaign$ = createEffect(() =>
        this.actions$.pipe(
            ofType(createCampaign),
            mergeMap((action) => {
                return this.service.create(action.campaign).pipe(
                    map(campaign => createCampaignSuccess({id: campaign.id})),
                    catchError(error => of(campaignsFailure({error})))
                );
            })
        )
    );

    createCampaignSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(createCampaignSuccess),
            mergeMap((action) => of(setCampaign({id: action.id})))
        )
    );

    deleteCampaign$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deleteCampaign),
            withLatestFrom(this.store.select(selectCurrentCampaignId)),
            mergeMap(([_, campaign]) => {
                return this.service.deleteCampaign(campaign).pipe(
                    map(_ => deleteCampaignSuccess()),
                    catchError(error => of(campaignsFailure({error})))
                );
            })
        )
    );

    deleteCampaignSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deleteCampaignSuccess),
            mergeMap((action) => of(exitCampaign()))
        )
    );

    constructor(
        private actions$: Actions,
        private store: Store,
        private service: CampaignsService
    ) {
    }
}
